export default __webpack_public_path__ + "static/media/help-rav-inv-2.d68e0404.png";